import { render } from "./LanguageShowComponent.vue?vue&type=template&id=be51befc"
import script from "./LanguageShowComponent.vue?vue&type=script&lang=js"
export * from "./LanguageShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Language/LanguageShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be51befc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be51befc', __exports__)) {
    api.reload('be51befc', __exports__)
  }
  
  module.hot.accept("./LanguageShowComponent.vue?vue&type=template&id=be51befc", () => {
    api.rerender('be51befc', render)
  })

}


export default __exports__